import {t} from 'i18next';
import PropTypes from 'prop-types';
import React from 'react';
import {withTranslation} from 'react-i18next';
import BaseListContainer from '../../baseContainers/BaseListContainer';
import ActionLink from '../../components/ActionLink';
import SettingService from '../../services/SettingService';
import {withRouter} from 'react-router-dom/cjs/react-router-dom.min';
import UserQuizService from '../../services/UserQuizService';
import DivContainer from '../../components/DivContainer';
import { CustomMessages } from '../../components/CustomMessages';
import BlockUi from '../../components/waitPanel/BlockUi';
import BaseBreadCrumb from '../../baseContainers/BaseBreadCrumb';
import { Card } from 'primereact';
import CriteriaTextComponent from '../../components/criteria/CriteriaTextComponent';
import CriteriaDropdownComponent from '../../components/criteria/CriteriaDropdownComponent';


class UserQuizListContainer extends BaseListContainer {
    constructor(props) {
        super(props, new UserQuizService());
        this.settingService = new SettingService();
        this.state = {
            list: [],
            loading: true,
            size: 0,
            first: 0,
            criteria: this.getCleanSearchCriteria(),
            filters: {},
        };
    }

    updateSearchCriteria(criteria) {
        return {
            quizId: this.props.quizId,
            firstResult: criteria.firstResult,
            maxResults: criteria.maxResults,
            sortField: criteria.sortField,
            sortAsc: criteria.sortAsc,
            email: criteria.email,
            name: criteria.name,
            status: criteria.status
        };
    }

    getCleanSearchCriteria() {
        return {
            firstResult: 0,
            maxResults: 10,
            sortField: 'coinsEarned',
            sortAsc: false,
            quizId: this.props.quizId,
            email: '',
            name: '',
            status: undefined
        };
    }

    initializeFromBackend() {
        this.enumService
            .getLocalizedEnumListForLocale('UserActivityStatus')
            .then((statuses) => {
                statuses = statuses.filter((status) => status.enumValue !== 'REMOVED');
                this.setState({
                    statuses,
                });
            })
            .catch((err) => {
                this.showErrorMessage(err.message);
            });
    }

    getDataKey() {
        return 'id';
    }
    getListTitle() {
        return 'quiz.listTitle';
    }
    getCriteriaName() {
        return 'quiz-list-sc';
    }

    getContainerListName() {
        return 'quiz-list-container';
    }

    renderCriteria() {
        return (
            <div className='row'>
                <CriteriaTextComponent
                    id='email-sc'
                    name='email'
                    label={t('user.email')}
                    colClass='col-lg-3 col-sm-6'
                    value={this.state.criteria.email}
                    onChange={this.handleChangeSc}
                    validator={this.validator}
                />
                <CriteriaTextComponent
                    id='name-sc'
                    name='name'
                    label={t('user.name')}
                    colClass='col-lg-3 col-sm-6'
                    value={this.state.criteria.name}
                    onChange={this.handleChangeSc}
                    validator={this.validator}
                />
                <CriteriaDropdownComponent
                    id='status'
                    name='status'
                    showClear
                    colClass='col-lg-3 col-sm-6'
                    label={t('user.list.criteria.status')}
                    value={this.state.criteria.status}
                    options={this.state.statuses}
                    placeholder={t('setting.all')}
                    onChange={this.handleChangeSc}
                    validator={this.validator}
                    filter
                />
            </div>
        );
    }

    prepareHeaderItems() {
        return [];
    }

    prepareColumns() {
        return [
            {
                field: 'email',
                header: t('mobileUser.email'),
                sortable: true,
                sortField:'user.email'
            },
            {
                field: 'name',
                header: t('login.form.userName'),
                sortable: true,
                sortField:'user.name'
            },
            {
                field: 'firstName',
                header: t('user.firstName'),
                sortable: true,
                sortField:'user.firstName'
            },
            {
                field: 'lastName',
                header: t('user.lastName'),
                sortable: true,
                sortField:'user.lastName'
            },
            {
                field: 'coinsEarned',
                header:  t('quiz.coinsEarned'),
                sortable: true,
            },
        ];
    }
    translate(key) {
        const {t} = this.props;
        return t(key);
    }

    //override
    actionTemplate(rowData) {
        const {detailUrl} = this.props;
        const detailHref = `${detailUrl}/${rowData?.id}/`+sessionStorage.getItem('i18nextLng');
        return (
            <div>
                <ActionLink
                    rendered={this.backLinkRendered}
                    className='p-link float-right'
                    handleClick={this.handleGoToDetail.bind(this, detailHref)}
                    variant='blue'
                    iconName='mdi-eye'
                    iconSide='right'
                    iconSize='xs'
                    iconColor='blue'
                />
                <span></span>
            </div>
        );
    }

    breadCrumbItems() {
        return [{name: t("userQuiz.listName"), url: '/quiz-list'}];
    }
    render() {
        return <div className='container-fluid'>{this.renderView()}</div>;
    }
    renderView() {
        const renderHeader = this.props.renderHeader === undefined || this.props.renderHeader === true;
        return (
            <DivContainer colClass=''>
                <CustomMessages id='custom-messages' ref={(el) => (this.messages = el)} />
                <BlockUi
                    tag='div'
                    blocking={this.state.blocking || this.state.loading}
                    loader={this.loader}
                    rendered={!this.props.embedded}
                >
                    <BaseBreadCrumb items={this.breadCrumbItems()} />

                    <div style={{
                        //minHeight: '900px'
                        }}>
                        <Card
                            className='list-card'
                            // header={this.renderHeader()}
                        >
                            <DivContainer colClass='row' rendered={this.props.hideFilters !== true}>
                                {this.renderFilter()}
                            </DivContainer>
                            <DivContainer colClass='row' rendered={renderHeader}>
                                {this.renderHeader()}
                            </DivContainer>
                            {this.renderDataTable(this.prepareColumns())}
                        </Card>
                    </div>
                </BlockUi>
            </DivContainer>
        );
    }
}

UserQuizListContainer.defaultProps = {
    renderChangeLanguegeFilter: true,
    lazy: true,
};

UserQuizListContainer.propTypes = {
    detailUrl: PropTypes.string,
    newUrl: PropTypes.string,
};

export default withRouter(withTranslation()(UserQuizListContainer));